import { render, staticRenderFns } from "./ClassAnalysis.vue?vue&type=template&id=88d8365c&scoped=true"
import script from "./ClassAnalysis.vue?vue&type=script&lang=js"
export * from "./ClassAnalysis.vue?vue&type=script&lang=js"
import style0 from "./ClassAnalysis.vue?vue&type=style&index=0&id=88d8365c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88d8365c",
  null
  
)

export default component.exports